import type { ReactElement } from "react";
import { Plus } from "lucide-react";

export function AddButton({
  onClick,
  children,
}: {
  readonly onClick: () => void;
  readonly children: string;
}): ReactElement {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1 rounded-md border border-pb-control-border bg-pb-card px-2.5 py-1 text-xs font-medium text-pb-text hover:pb-overlay-paint"
    >
      <Plus className="h-3.5 w-3.5" />
      {children}
    </button>
  );
}
